import { css, CSSResult } from 'lit'
import { csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cscStockIndication = {
  outOfStockColor: css`var(--csc-stock-indication-out-of-stock-background-color, var(--csc-stock-indication-out-of-stock-color, ${csColorFunctional.error}))`,
  inStockColor: css`var(--csc-stock-indication-in-stock-background-color, var(--csc-stock-indication-in-stock-color, ${csColorFunctional.success}))`,
  warningStockColor: css`var(--csc-stock-indication-warning-stock-background-color, var(--csc-stock-indication-warning-stock-color, ${csColorFunctional.warning}))`,
  columnGap: css`var(--csc-stock-indication-wrapper-gap, ${csSpacing.spacing04})`,
  indicationSuccessColor: css`var(--csc-stock-indication-indication-success-background-color, ${csColorFunctional.success})`,
  indicationWarningColor: css`var(--csc-stock-indication-indication-warning-background-color, ${csColorFunctional.warning})`,
  indicationErrorColor: css`var(--csc-stock-indication-indication-error-background-color, ${csColorFunctional.error})`,
  indicationInfoColor: css`var(--csc-stock-indication-indication-info-background-color, ${csColorFunctional.info})`,
}

export const style: CSSResult = css`
  cse-badge[variant="error"] {
    --cse-badge-error-background-color: ${cscStockIndication.outOfStockColor};
  }

  cse-badge[variant="success"] {
    --cse-badge-success-background-color: ${cscStockIndication.inStockColor};
  }

  cse-badge[variant="warning"] {
    --cse-badge-warning-background-color: ${cscStockIndication.warningStockColor};
  }

  cse-badge.indication-success {
    --cse-badge-success-background-color: ${cscStockIndication.indicationSuccessColor};
  }

  cse-badge.indication-warning {
    --cse-badge-warning-background-color: ${cscStockIndication.indicationWarningColor};
  }

  cse-badge.indication-error {
    --cse-badge-error-background-color: ${cscStockIndication.indicationErrorColor};
  }

  cse-badge.indication-info {
    --cse-badge-info-background-color: ${cscStockIndication.indicationInfoColor};
  }

  .csc-stock-indication-wrapper {
    display: flex;
    align-items: center;
    gap: ${cscStockIndication.columnGap}
  }

  .csc-stock-indication-wrapper cse-tooltip {
    display: flex;
  }
`
